'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _FormattingUtils = require('../../../utils/FormattingUtils');

var FormattingUtils = _interopRequireWildcard(_FormattingUtils);

var _languageHandler = require('../../../languageHandler');

var _crypto = require('matrix-js-sdk/lib/crypto');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODE_LEGACY = 'legacy'; /*
                            Copyright 2016 OpenMarket Ltd
                            Copyright 2017 Vector Creations Ltd
                            Copyright 2019 New Vector Ltd
                            Copyright 2019 Michael Telatynski <7t3chguy@gmail.com>
                            
                            Licensed under the Apache License, Version 2.0 (the "License");
                            you may not use this file except in compliance with the License.
                            You may obtain a copy of the License at
                            
                                http://www.apache.org/licenses/LICENSE-2.0
                            
                            Unless required by applicable law or agreed to in writing, software
                            distributed under the License is distributed on an "AS IS" BASIS,
                            WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                            See the License for the specific language governing permissions and
                            limitations under the License.
                            */

var MODE_SAS = 'sas';

var PHASE_START = 0;
var PHASE_WAIT_FOR_PARTNER_TO_ACCEPT = 1;
var PHASE_SHOW_SAS = 2;
var PHASE_WAIT_FOR_PARTNER_TO_CONFIRM = 3;
var PHASE_VERIFIED = 4;
var PHASE_CANCELLED = 5;

var DeviceVerifyDialog = function (_React$Component) {
    (0, _inherits3.default)(DeviceVerifyDialog, _React$Component);

    function DeviceVerifyDialog() {
        (0, _classCallCheck3.default)(this, DeviceVerifyDialog);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DeviceVerifyDialog.__proto__ || (0, _getPrototypeOf2.default)(DeviceVerifyDialog)).call(this));

        _this._onSwitchToLegacyClick = function () {
            if (_this._verifier) {
                _this._verifier.removeListener('show_sas', _this._onVerifierShowSas);
                _this._verifier.cancel('User cancel');
                _this._verifier = null;
            }
            _this.setState({ mode: MODE_LEGACY });
        };

        _this._onSwitchToSasClick = function () {
            _this.setState({ mode: MODE_SAS });
        };

        _this._onCancelClick = function () {
            _this.props.onFinished(false);
        };

        _this._onLegacyFinished = function (confirm) {
            if (confirm) {
                _MatrixClientPeg2.default.get().setDeviceVerified(_this.props.userId, _this.props.device.deviceId, true);
            }
            _this.props.onFinished(confirm);
        };

        _this._onSasRequestClick = function () {
            _this.setState({
                phase: PHASE_WAIT_FOR_PARTNER_TO_ACCEPT
            });
            _this._verifier = _MatrixClientPeg2.default.get().beginKeyVerification(_crypto.verificationMethods.SAS, _this.props.userId, _this.props.device.deviceId);
            _this._verifier.on('show_sas', _this._onVerifierShowSas);
            _this._verifier.verify().then(function () {
                _this.setState({ phase: PHASE_VERIFIED });
                _this._verifier.removeListener('show_sas', _this._onVerifierShowSas);
                _this._verifier = null;
            }).catch(function (e) {
                console.log("Verification failed", e);
                _this.setState({
                    phase: PHASE_CANCELLED
                });
                _this._verifier = null;
            });
        };

        _this._onSasMatchesClick = function () {
            _this._showSasEvent.confirm();
            _this.setState({
                phase: PHASE_WAIT_FOR_PARTNER_TO_CONFIRM
            });
        };

        _this._onVerifiedDoneClick = function () {
            _this.props.onFinished(true);
        };

        _this._onVerifierShowSas = function (e) {
            _this._showSasEvent = e;
            _this.setState({
                phase: PHASE_SHOW_SAS
            });
        };

        _this._verifier = null;
        _this._showSasEvent = null;
        _this.state = {
            phase: PHASE_START,
            mode: MODE_SAS,
            sasVerified: false
        };
        return _this;
    }

    (0, _createClass3.default)(DeviceVerifyDialog, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this._verifier) {
                this._verifier.removeListener('show_sas', this._onVerifierShowSas);
                this._verifier.cancel('User cancel');
            }
        }
    }, {
        key: '_renderSasVerification',
        value: function _renderSasVerification() {
            var body = void 0;
            switch (this.state.phase) {
                case PHASE_START:
                    body = this._renderSasVerificationPhaseStart();
                    break;
                case PHASE_WAIT_FOR_PARTNER_TO_ACCEPT:
                    body = this._renderSasVerificationPhaseWaitAccept();
                    break;
                case PHASE_SHOW_SAS:
                    body = this._renderSasVerificationPhaseShowSas();
                    break;
                case PHASE_WAIT_FOR_PARTNER_TO_CONFIRM:
                    body = this._renderSasVerificationPhaseWaitForPartnerToConfirm();
                    break;
                case PHASE_VERIFIED:
                    body = this._renderSasVerificationPhaseVerified();
                    break;
                case PHASE_CANCELLED:
                    body = this._renderSasVerificationPhaseCancelled();
                    break;
            }

            var BaseDialog = _index2.default.getComponent("dialogs.BaseDialog");
            return _react2.default.createElement(
                BaseDialog,
                {
                    title: (0, _languageHandler._t)("Verify device"),
                    onFinished: this._onCancelClick
                },
                body
            );
        }
    }, {
        key: '_renderSasVerificationPhaseStart',
        value: function _renderSasVerificationPhaseStart() {
            var AccessibleButton = _index2.default.getComponent('views.elements.AccessibleButton');
            var DialogButtons = _index2.default.getComponent('views.elements.DialogButtons');
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    AccessibleButton,
                    {
                        element: 'span', className: 'mx_linkButton', onClick: this._onSwitchToLegacyClick
                    },
                    (0, _languageHandler._t)("Use Legacy Verification (for older clients)")
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("Verify by comparing a short text string.")
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("For maximum security, we recommend you do this in person or " + "use another trusted means of communication.")
                ),
                _react2.default.createElement(DialogButtons, {
                    primaryButton: (0, _languageHandler._t)('Begin Verifying'),
                    hasCancel: true,
                    onPrimaryButtonClick: this._onSasRequestClick,
                    onCancel: this._onCancelClick
                })
            );
        }
    }, {
        key: '_renderSasVerificationPhaseWaitAccept',
        value: function _renderSasVerificationPhaseWaitAccept() {
            var _this2 = this;

            var Spinner = _index2.default.getComponent("views.elements.Spinner");
            var AccessibleButton = _index2.default.getComponent('views.elements.AccessibleButton');

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(Spinner, null),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("Waiting for partner to accept...")
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("Nothing appearing? Not all clients support interactive verification yet. " + "<button>Use legacy verification</button>.", {}, { button: function button(sub) {
                            return _react2.default.createElement(
                                AccessibleButton,
                                { element: 'span', className: 'mx_linkButton',
                                    onClick: _this2._onSwitchToLegacyClick
                                },
                                sub
                            );
                        } })
                )
            );
        }
    }, {
        key: '_renderSasVerificationPhaseShowSas',
        value: function _renderSasVerificationPhaseShowSas() {
            var VerificationShowSas = _index2.default.getComponent('views.verification.VerificationShowSas');
            return _react2.default.createElement(VerificationShowSas, {
                sas: this._showSasEvent.sas,
                onCancel: this._onCancelClick,
                onDone: this._onSasMatchesClick
            });
        }
    }, {
        key: '_renderSasVerificationPhaseWaitForPartnerToConfirm',
        value: function _renderSasVerificationPhaseWaitForPartnerToConfirm() {
            var Spinner = _index2.default.getComponent('views.elements.Spinner');
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(Spinner, null),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("Waiting for %(userId)s to confirm...", { userId: this.props.userId })
                )
            );
        }
    }, {
        key: '_renderSasVerificationPhaseVerified',
        value: function _renderSasVerificationPhaseVerified() {
            var VerificationComplete = _index2.default.getComponent('views.verification.VerificationComplete');
            return _react2.default.createElement(VerificationComplete, { onDone: this._onVerifiedDoneClick });
        }
    }, {
        key: '_renderSasVerificationPhaseCancelled',
        value: function _renderSasVerificationPhaseCancelled() {
            var VerificationCancelled = _index2.default.getComponent('views.verification.VerificationCancelled');
            return _react2.default.createElement(VerificationCancelled, { onDone: this._onCancelClick });
        }
    }, {
        key: '_renderLegacyVerification',
        value: function _renderLegacyVerification() {
            var QuestionDialog = _index2.default.getComponent("dialogs.QuestionDialog");
            var AccessibleButton = _index2.default.getComponent('views.elements.AccessibleButton');

            var text = void 0;
            if (_MatrixClientPeg2.default.get().getUserId() === this.props.userId) {
                text = (0, _languageHandler._t)("To verify that this device can be trusted, please check that the key you see " + "in User Settings on that device matches the key below:");
            } else {
                text = (0, _languageHandler._t)("To verify that this device can be trusted, please contact its owner using some other " + "means (e.g. in person or a phone call) and ask them whether the key they see in their User Settings " + "for this device matches the key below:");
            }

            var key = FormattingUtils.formatCryptoKey(this.props.device.getFingerprint());
            var body = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    AccessibleButton,
                    {
                        element: 'span', className: 'mx_linkButton', onClick: this._onSwitchToSasClick
                    },
                    (0, _languageHandler._t)("Use two-way text verification")
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    text
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_DeviceVerifyDialog_cryptoSection' },
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'label',
                                null,
                                (0, _languageHandler._t)("Device name"),
                                ':'
                            ),
                            ' ',
                            _react2.default.createElement(
                                'span',
                                null,
                                this.props.device.getDisplayName()
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'label',
                                null,
                                (0, _languageHandler._t)("Device ID"),
                                ':'
                            ),
                            ' ',
                            _react2.default.createElement(
                                'span',
                                null,
                                _react2.default.createElement(
                                    'code',
                                    null,
                                    this.props.device.deviceId
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'label',
                                null,
                                (0, _languageHandler._t)("Device key"),
                                ':'
                            ),
                            ' ',
                            _react2.default.createElement(
                                'span',
                                null,
                                _react2.default.createElement(
                                    'code',
                                    null,
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        key
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("If it matches, press the verify button below. " + "If it doesn't, then someone else is intercepting this device " + "and you probably want to press the blacklist button instead.")
                )
            );

            return _react2.default.createElement(QuestionDialog, {
                title: (0, _languageHandler._t)("Verify device"),
                description: body,
                button: (0, _languageHandler._t)("I verify that the keys match"),
                onFinished: this._onLegacyFinished
            });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.mode === MODE_LEGACY) {
                return this._renderLegacyVerification();
            } else {
                return _react2.default.createElement(
                    'div',
                    null,
                    this._renderSasVerification()
                );
            }
        }
    }]);
    return DeviceVerifyDialog;
}(_react2.default.Component);

DeviceVerifyDialog.propTypes = {
    userId: _propTypes2.default.string.isRequired,
    device: _propTypes2.default.object.isRequired,
    onFinished: _propTypes2.default.func.isRequired
};
exports.default = DeviceVerifyDialog;
module.exports = exports['default'];
//# sourceMappingURL=DeviceVerifyDialog.js.map